module.exports = __webpack_public_path__ + "static/media/icons8-linkedin-logo.2c20928d.svg";